__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__GQ4XwG__accordion",
  "accordion__label": "accordion-module-scss-module__GQ4XwG__accordion__label",
  "accordion__plus-minus": "accordion-module-scss-module__GQ4XwG__accordion__plus-minus",
  "accordion__trigger": "accordion-module-scss-module__GQ4XwG__accordion__trigger",
  "accordion__trigger--spaced-out": "accordion-module-scss-module__GQ4XwG__accordion__trigger--spaced-out",
  "accordion__trigger-icon": "accordion-module-scss-module__GQ4XwG__accordion__trigger-icon",
  "accordion__trigger-icon--is-open": "accordion-module-scss-module__GQ4XwG__accordion__trigger-icon--is-open",
  "toggle-icon": "accordion-module-scss-module__GQ4XwG__toggle-icon",
});
